var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "twitter-a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "1 0 0 0 0                 0 1 0 0 0                 0 0 1 0 0                 0 0 0 1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#twitter-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M32,16 C32,24.84 24.84,32 16,32 C7.16,32 0,24.84 0,16 C0,7.16 7.16,0 16,0 C24.84,0 32,7.16 32,16 Z M13.072,24.44 C20.168,24.44 24.048,18.56 24.048,13.464 C24.048,13.296 24.048,13.128 24.04,12.968 C24.792,12.424 25.448,11.744 25.968,10.968 C25.28,11.272 24.536,11.48 23.752,11.576 C24.552,11.096 25.16,10.344 25.448,9.44 C24.704,9.88 23.88,10.2 23,10.376 C22.296,9.624 21.296,9.16 20.184,9.16 C18.056,9.16 16.328,10.888 16.328,13.016 C16.328,13.32 16.36,13.616 16.432,13.896 C13.224,13.736 10.384,12.2 8.48,9.864 C8.152,10.432 7.96,11.096 7.96,11.8 C7.96,13.136 8.64,14.32 9.68,15.008 C9.048,14.992 8.456,14.816 7.936,14.528 C7.936,14.544 7.936,14.56 7.936,14.576 C7.936,16.448 9.264,18 11.032,18.36 C10.712,18.448 10.368,18.496 10.016,18.496 C9.768,18.496 9.528,18.472 9.288,18.424 C9.776,19.96 11.2,21.072 12.888,21.104 C11.568,22.136 9.904,22.752 8.096,22.752 C7.784,22.752 7.48,22.736 7.176,22.696 C8.864,23.8 10.896,24.44 13.072,24.44 L13.072,24.44 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.5fae5c0f.svg";
export { ForwardRef as ReactComponent };